import {Link} from "react-router-dom";
import React from "react";

const FormSteps = (props) => {
  const {
    items,
    currentStep
  } = props;

  const isActive = (name) => currentStep === name;

  return (
    <div className="form-steps">
      {items.map((item) => (
        <div key={item.name} className={`form-step ${isActive(item.name) ? 'active' : ''}`}>
          {item.step} {item.label}
        </div>
      ))}
    </div>
  );
}

export default FormSteps;